module.exports = __webpack_public_path__ + "img/diamante-i.d3ead075.png";